import React, { Fragment, useContext, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import { BasicContext } from "../../App";
import { validateEmail } from "../../commonData";
import Email from "../inputs/Email";
import { postMethod } from "../../requests";

const AddInstructorModal = (props) => {
    const { t } = useTranslation();
    const { onClose, onProceed } = props;
    const { checkServerData, setAlerts } = useContext(BasicContext);
    const [blockForm, setBlockForm] = useState(false);
    const [formChanged, setFormChanged] = useState(false);
    const [user, setUser] = useState({
        email: "",
        name: "",
        surname: "",
        ig: "",
        phone: "",
        userRole: "INSTRUCTOR",
    });

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (user.email.length === 0 || !user.email.replace(/\s+/, "")) {
            $("#addUserFormEmail").addClass("is-invalid");
            errors.push(t("error.emptyEmail"));
        } else if (!validateEmail(user.email)) {
            $("#addUserFormEmail").addClass("is-invalid");
            errors.push(t("error.invalidEmail"));
        } else if (user.email.length > 255) {
            $("#addUserFormEmail").addClass("is-invalid");
            errors.push(t("error.userEmailTooLong"));
        }

        if (user.name.length === 0 || !user.name.replace(/\s+/, "")) {
            $("#addUserFormname").addClass("is-invalid");
            errors.push(t("error.emptyName"));
        } else if (user.name.length > 50) {
            $("#addUserFormname").addClass("is-invalid");
            errors.push(t("error.userNameTooLong"));
        }

        if (user.surname.length === 0 || !user.surname.replace(/\s+/, "")) {
            $("#addUserFormsurname").addClass("is-invalid");
            errors.push(t("error.emptySurname"));
        } else if (user.surname.length > 50) {
            $("#addUserFormsurname").addClass("is-invalid");
            errors.push(t("error.userSurnameTooLong"));
        }

        if (user.phone.length === 0 || !user.phone.replace(/\s+/, "")) {
            $("#addUserFormphone").addClass("is-invalid");
            errors.push(t("error.emptyPhone"));
        } else if (!/^(\+48\s?)?(\d{3}\s?\d{3}\s?\d{3})$/.test(user.phone)) {
            $("#addUserFormphone").addClass("is-invalid");
            errors.push(t("error.invalidPhone"));
        } else if (user.phone.length > 30) {
            $("#addUserFormphone").addClass("is-invalid");
            errors.push(t("error.userPhoneTooLong"));
        }

        if (user.ig.length > 0 && !/^(?!.*\.\.)(?!.*\.$)(?!\d+$)[a-zA-Z0-9._]{1,30}$/.test(user.ig)) {
            $("#addUserFormig").addClass("is-invalid");
            errors.push(t("error.invalidIgNick"));
        } else if (user.ig.length > 0 && user.ig.length > 30) {
            $("#addUserFormig").addClass("is-invalid");
            errors.push(t("error.userInstagramTooLong"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t("info.creatingNewUser") }]);
            setBlockForm(true);
            addNewUser();
        }
    };

    const addNewUser = async () => {
        const res = await postMethod("/add-user", { user: user });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t("success.userAdded"), fading: 1500, id: "added" }]);
            onProceed();
        } else setBlockForm(false);
    };

    const textInputs = [
        { name: "name", req: true },
        { name: "surname", req: true },
        { name: "phone", req: true },
        { name: "ig", req: false },
    ];

    return (
        <Fragment>
            <Modal show={true} onHide={onClose} backdrop={formChanged ? "static" : true}>
                <Form onSubmit={checkValidation} autoComplete="off">
                    <Modal.Header closeButton>
                        <Modal.Title>{t("users.addNewInstructor")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col xs={12} className="mb-3">
                                <input type="text" name="prevent-autofill" id="prevent-autofill" style={{ display: "none" }} autoComplete="off" />
                                <Row>
                                    <Col xs={12}>
                                        <Email
                                            id="addUserFormEmail"
                                            onChange={(e) => {
                                                $(`#addUserFormEmail`).removeClass("is-invalid");
                                                setUser({ ...user, email: e.target.value });
                                                setFormChanged(true);
                                            }}
                                            blockForm={blockForm}
                                            value={user.email}
                                            autoComplete="off"
                                        />
                                    </Col>
                                    {textInputs.map((e, i) => (
                                        <Col xs={12}>
                                            <Form.Group key={i} className="mb-3" controlId={`addUserForm${e.name}`}>
                                                <Form.Label className="w-100">
                                                    {t(`addUserForm.${e.name}`)} {e.req && <span className="text-danger">*</span>}
                                                </Form.Label>
                                                <Form.Control
                                                    value={user[e.name]}
                                                    onChange={(el) => {
                                                        $(`#addUserForm${e.name}`).removeClass("is-invalid");
                                                        setUser({ ...user, [e.name]: el.target.value });
                                                        setFormChanged(true);
                                                    }}
                                                    placeholder={t(`addUserForm.${e.name}Placeholder`)}
                                                    type="text"
                                                    disabled={blockForm}
                                                />
                                            </Form.Group>
                                        </Col>
                                    ))}
                                </Row>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-secondary" onClick={onClose}>
                            {t("cancel")}
                        </Button>
                        <Button variant="primary" type="submit" disabled={!formChanged || blockForm}>
                            {t("create")}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </Fragment>
    );
};

export default AddInstructorModal;
